import './base'
import { ProjectPageLoader } from 'src/ppp'
import { mountOnId } from 'src/shared'

document.addEventListener('DOMContentLoaded', () => {
  mountOnId(ProjectPageLoader, 'ppp')
})
